module.exports = __webpack_public_path__ + "img/app4.0c7dcc83.jpg";